var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.033,
    height: 21.03,
    viewBox: "0 0 21.033 21.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map",
    transform: "translate(-1.996 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55294",
    "data-name": "Path 55294",
    d: "M16.27,2A6.732,6.732,0,0,0,9.51,8.76a8.138,8.138,0,0,0,1.052,3.755h-1.8a.452.452,0,0,0-.3.075c-.075.075-.15.075-.225.15L2.224,18.749a.686.686,0,0,0-.15.826.722.722,0,0,0,.676.451H7.707L10.486,22.8a.682.682,0,0,0,.526.225H16.27a.452.452,0,0,0,.3-.075c.075-.075.15-.075.225-.15L22.8,16.8c.075-.075.15-.15.15-.225a.823.823,0,0,0,0-.6.905.905,0,0,0-.376-.376.452.452,0,0,0-.3-.075H19.8c1.652-1.878,3.23-4.281,3.23-6.76A6.732,6.732,0,0,0,16.27,2Zm0,1.5A5.225,5.225,0,0,1,21.527,8.76c0,2.7-2.554,5.558-4.056,6.985a11.862,11.862,0,0,1-1.2,1.052,19.679,19.679,0,0,1-3.68-3.981A7.32,7.32,0,0,1,11.012,8.76,5.225,5.225,0,0,1,16.27,3.5ZM8.533,18.749a.682.682,0,0,0-.526-.225H4.553l4.506-4.506h2.479a21.634,21.634,0,0,0,4.281,4.356,1.068,1.068,0,0,0,.451.15,1.068,1.068,0,0,0,.451-.15s.676-.526,1.577-1.352h2.178l-4.506,4.506H11.312Z",
    transform: "translate(0 0)",
    fill: "#00d297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55295",
    "data-name": "Path 55295",
    d: "M19.755,13.311A3.755,3.755,0,1,0,16,9.555,3.719,3.719,0,0,0,19.755,13.311Zm0-6.009A2.253,2.253,0,1,1,17.5,9.555,2.213,2.213,0,0,1,19.755,7.3Z",
    transform: "translate(-3.486 -0.946)",
    fill: "#00d297"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapActive);
export default __webpack_public_path__ + "static/media/map-active.1cf7041dfc74992459b01a38d15116a7.svg";
export { ForwardRef as ReactComponent };